// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"131":"accordion","897":"carousel"}[chunkId] || chunkId) + "." + {"131":"49f8d7ecfeae892417d6","897":"ea2095c7089ecf5e5b23","902":"01aa92e68a8cbf0b6f8e"}[chunkId] + ".js";
};